import { useState, useCallback } from "react";

export function useVisualiser(barCount = 16) {
  const [heights, setHeights] = useState<number[]>(() => Array(barCount).fill(3));

  const update = useCallback((samples: Float32Array) => {
    const step = Math.max(1, Math.floor(samples.length / barCount));
    const newHeights = Array.from({ length: barCount }, (_, i) => {
      let sum = 0;
      for (let j = 0; j < step; j++) sum += Math.abs(samples[i * step + j] ?? 0);
      return Math.max(3, Math.round((sum / step) * 140));
    });
    setHeights(newHeights);
  }, [barCount]);

  const reset = useCallback(() => {
    setHeights(Array(barCount).fill(3));
  }, [barCount]);

  return { heights, update, reset };
}
